// extracted by mini-css-extract-plugin
module.exports = {"label":"style_label__1vN4r","inputWrap":"style_inputWrap__2VoGr","input":"style_input__W2h2u","inputCenter":"style_inputCenter__2VahV"};